// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "segment__totalDuration-Q-_bW";
var _3 = "segment__planeInfo-2aCYq";
var _4 = "segment__aircraft-2GJPg";
var _5 = "segment__amenities-Wy4rg";
export { _1 as "__esModule", _2 as "segment__totalDuration", _3 as "segment__planeInfo", _4 as "segment__aircraft", _5 as "segment__amenities" }
export default { "__esModule": _1, "segment__totalDuration": _2, "segment__planeInfo": _3, "segment__aircraft": _4, "segment__amenities": _5 }
